import React, { useState } from 'react';
import Head from 'next/head';

import { useSelector } from 'store';
import ImageSlider from 'components/common/ImageSlider';
import InfoSlider from 'components/common/InfoSlider';
import Modal from 'components/common/Modal';
import styled from 'styled-components';
import ModalMapPopup from './components/ModalMapPopup';

const PlaceDetailService: React.FC = () => {
  const branch = useSelector(state => state.space.branch);
  const { floors } = branch;
  const { features } = branch;

  const [isHoverOnMapIcon, setIsHoverOnMap] = useState(false);

  const kakao = branch.map_url_kakao;
  const google = branch.map_url_google;
  const naver = branch.map_url_naver;

  const { openModal, closeModal, ModalPortal } = Modal();

  return (
    <>
      <Head>
        <title>{`로컬스티치 - ${branch.name}`}</title>
        <meta name="application-name" content={`로컬스티치 - ${branch.name}`} />
        <meta
          name="msapplication-tooltip"
          content={`로컬스티치 - ${branch.name}`}
        />
        <meta
          id="meta_og_title"
          property="og:title"
          content={`로컬스티치 - ${branch.name}`}
        />
        {branch.name === '을지로' && (
          <>
            <script>
              {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1058468068326629');
          fbq('track', 'PageView');`}
            </script>
            <noscript>
              <img
                alt=" "
                height="1"
                width="1"
                style={{ display: 'none' }}
                src="https://www.facebook.com/tr?id=1058468068326629&ev=PageView&noscript=1"
              />
            </noscript>
          </>
        )}
      </Head>
      <div className="s-menu">
        <ul>
          <li className="selected">
            <a style={{ cursor: 'default' }}>{branch.region.name}</a>
          </li>
        </ul>
      </div>
      <div className="cnts-wrap">
        <div className="retail-detail branch-type">
          <div className="hgroup">
            <img src={branch.representation_image} className="img" alt="" />
            <h2>{branch.name}</h2>
            <address>{branch.address}</address>
            <div
              className="btn-map"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <OpenMapModalButton
                onClick={openModal}
                onPointerEnter={() => setIsHoverOnMap(true)}
                onPointerLeave={() => setIsHoverOnMap(false)}
              >
                <img
                  src={
                    isHoverOnMapIcon
                      ? '/images/map-gray.svg'
                      : '/images/map.svg'
                  }
                  alt=""
                  style={{ width: 28, height: 28 }}
                />
                <span
                  style={{
                    color: isHoverOnMapIcon ? '#808080' : '#111',
                    marginLeft: 8,
                  }}
                >
                  지도 보기
                </span>
              </OpenMapModalButton>
              <div>
                <span>
                  <OpenMapPageAnchor
                    href={kakao}
                    target="_blank"
                    rel="noreferrer"
                  >
                    카카오
                  </OpenMapPageAnchor>
                </span>
                <span style={{ margin: 6 }}>·</span>
                <span>
                  <OpenMapPageAnchor
                    href={google}
                    target="_blank"
                    rel="noreferrer"
                  >
                    구글
                  </OpenMapPageAnchor>
                </span>
                <span style={{ margin: 6 }}>·</span>
                <span>
                  <OpenMapPageAnchor
                    href={naver}
                    target="_blank"
                    rel="noreferrer"
                  >
                    네이버
                  </OpenMapPageAnchor>
                </span>
              </div>
            </div>
            {branch.button_text && (
              <a
                href={branch.button_url}
                style={{
                  display: 'block',
                  border: '2px solid #111',
                  padding: 12,
                  margin: '20px auto 0 auto',
                  width: '70%',
                  fontWeight: 'bold',
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {branch.button_text}
              </a>
            )}
          </div>
          <ImageSlider images={branch.images} />
          <div className="detail-cnts">
            <p style={{ whiteSpace: 'pre-line' }}>{branch.introduction}</p>
          </div>
          <div className="retail-info">
            <h3>{branch.name} 특징</h3>
            <ul>
              {features.map((feature, index) => {
                return <li key={index}>{feature.text}</li>;
              })}
            </ul>
          </div>
          <div className="space-guide">
            <h3>층별 안내</h3>
            <InfoSlider floors={floors} />
          </div>

          {branch.button_text && (
            <a
              href={branch.button_url}
              style={{
                display: 'block',
                border: '2px solid #111',
                padding: 16,
                margin: '20px auto 0 auto',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {branch.button_text}
            </a>
          )}
        </div>
      </div>
      <ModalPortal>
        <ModalMapPopup closeModal={closeModal} branch={branch} />
      </ModalPortal>
    </>
  );
};

const OpenMapModalButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 8px;
  padding-right: 8px;
  border-right: 1px solid #111;
`;

const OpenMapPageAnchor = styled.a`
  :hover {
    color: #808080;
  }
`;

export default PlaceDetailService;
